import IProductConfigurationItem from 'api/interfaces/products/IProductConfigurationItem';
import { M2 } from 'services/enums/units';

import {
  EXPENSE,
  EXPENSE_UNIT,
  PRODUCT_ID,
  QUANTITY,
  QUANTITY_UNIT,
  SELLING_PRICE,
  SELLING_PRICE_UNIT,
  WASTE_PERCENTAGE,
} from 'services/products/productConfigurationAttributeTypes';

const getDefaultProductDetailItem = (
  type: string
): IProductConfigurationItem => ({
  attributes: [
    { type: EXPENSE, value: '' },
    { type: EXPENSE_UNIT, value: M2 },
    { type: PRODUCT_ID, value: '' },
    { type: QUANTITY, value: '' },
    { type: QUANTITY_UNIT, value: M2 },
    { type: SELLING_PRICE, value: '' },
    { type: SELLING_PRICE_UNIT, value: '' },
    { type: WASTE_PERCENTAGE, value: '' },
  ],
  children: [],
  sortIndex: 0,
  type,
});

export default getDefaultProductDetailItem;
